import React from 'react';
import { BiSolidEdit } from 'react-icons/bi';
import { FaCheck } from 'react-icons/fa6';

const ORDER_DELIVERY_CLASS_NAMES = {
  IN_PROGRESS: 'danger-hollow-pill',
  LOADING: 'warning-hollow-pill',
  DISPATCHED: 'success-hollow-pill',
  DELIVERED: 'primary-hollow-pill',
  PENDING: 'danger-hollow-pill',
};

export const RATE_CARD_DETAILS_ORDERS_TABLE_COLUMNS = [
  {
    accessorKey: 'serialNumber',
    header: 'S.NO.',
    enableSorting: false,
    cell: ({ getValue }) => (
      <div style={{ textAlign: 'center' }}>{getValue()}</div>
    ),
  },

  {
    accessorKey: 'orderId',
    header: 'Order ID',
    enableSorting: false,
    cell: ({ getValue }) => (
      <div style={{ textAlign: 'center', color: '#2378C9' }}>{getValue()}</div>
    ),
  },

  {
    accessorKey: 'sellerAddress',
    header: "Seller 's Address",
    enableSorting: false,
  },

  {
    accessorKey: 'buyerAddress',
    header: "Buyer 's Address",
    enableSorting: false,
  },
  {
    accessorKey: 'logisticPartner',
    header: 'Logistic Partner',
    enableSorting: false,
    cell: ({ getValue }) => (
      <div style={{ textAlign: 'center', color: !getValue() ? '#FD7E14' : '' }}>
        {!getValue() ? 'Not Assigned' : getValue()}
      </div>
    ),
  },

  {
    accessorKey: 'rate',
    header: 'Rate',
    enableSorting: false,
    cell: ({ getValue }) => (
      <div style={{ textAlign: 'center', color: '#1BA325' }}>
        {!getValue() ? '-' : getValue()}
      </div>
    ),
  },
  {
    accessorKey: 'deliveryStatus',
    header: 'Delivery Status',
    enableSorting: false,
    cell: ({ getValue }) => (
      <div className="d-flex align-items-center justify-content-center">
        <button
          type="button"
          disabled
          className={ORDER_DELIVERY_CLASS_NAMES[getValue()] || ''}
        >
          {getValue() === 'IN_PROGRESS' ? 'PENDING' : getValue()}
        </button>
      </div>
    ),
  },
];

export const RATE_CARD_DETAILS_TABLE_COLUMNS = [
  {
    header: 'From PIN',
    enableSorting: false,
    cell: ({
      row: {
        original: { from, fromCityName, fromStateName },
      },
    }) => (
      <div className="d-flex flex-column" style={{ minWidth: 125 }}>
        <span>{from}</span>
        {fromCityName && (
          <span>
            {fromCityName}, {fromStateName}
          </span>
        )}
      </div>
    ),
  },

  {
    header: 'To PIN',
    enableSorting: false,
    cell: ({
      row: {
        original: { to, toCityName, toStateName },
      },
    }) => (
      <div className="d-flex flex-column" style={{ minWidth: 125 }}>
        <span>{to}</span>
        {toCityName && (
          <span>
            {toCityName}, {toStateName}
          </span>
        )}
      </div>
    ),
  },

  {
    header: 'Provided By',
    enableSorting: false,
    cell: ({
      row: {
        original: { providedBy },
      },
    }) => providedBy,
  },

  {
    header: 'Vehicle Types',
    enableSorting: false,
    cell: ({
      row: {
        original: { vehicleType },
      },
    }) => vehicleType,
  },

  {
    header: 'Rate',
    enableSorting: false,
    cell: ({
      row: {
        original: { rate },
      },
    }) => rate,
  },

  {
    header: 'Validity',
    enableSorting: false,
    cell: ({
      row: {
        original: { validityTill },
      },
    }) =>
      Intl.DateTimeFormat('en-GB', 'dd/mm/yyyy').format(
        new Date(validityTill * 1000),
      ),
  },

  {
    accessorKey: 'status',
    header: 'Status',
    enableSorting: false,
  },

  {
    accessorKey: 'editRate',
    header: ' ',
    enableSorting: false,
    cell: () => <BiSolidEdit size={22} />,
  },
];

export const DELIVERY_RATE_REQUEST_TABLE_COLUMNS = [
  {
    accessorKey: 'serialNumber',
    header: 'S.NO.',
    enableSorting: false,
    size: 5,
    cell: ({ getValue }) => (
      <div style={{ textAlign: 'center' }}>{getValue()}</div>
    ),
  },

  {
    accessorKey: 'id',
    header: 'Request ID',
    enableSorting: false,
    size: 10,
    cell: ({ getValue }) => (
      <div style={{ color: '#2378C9' }}>{getValue()}</div>
    ),
  },

  {
    accessorKey: 'from',
    header: 'From PIN',
    size: 10,
    enableSorting: false,
    cell: (row) => {
      return (
        <div className="d-flex flex-column">
          <span className="fw-semibold">{row?.row?.original?.from}</span>
          <span>
            {row?.row?.original?.fromCityName},{' '}
            {row?.row?.original?.fromStateName}
          </span>
        </div>
      );
    },
  },

  {
    accessorKey: 'to',
    header: 'To PIN',
    enableSorting: false,
    cell: (row) => {
      return (
        <div className="d-flex flex-column">
          <span className="fw-semibold">{row?.row?.original?.to}</span>
          <span>
            {row?.row?.original?.toCityName}, {row?.row?.original?.toStateName}
          </span>
        </div>
      );
    },
  },
  {
    accessorKey: 'buyer',
    header: 'Buyer',
    enableSorting: false,
    cell: ({ getValue }) => {
      return <div>{getValue()}</div>;
    },
  },

  {
    accessorKey: 'action',
    header: '',
    enableSorting: false,
  },
];
